import type { Header } from "@tanstack/react-table";

type ColumnResizeHandleProps<T> = {
  header: Header<T, unknown>;
};

export function ColumnResizeHandle<T>({ header }: ColumnResizeHandleProps<T>) {
  if (!header.column.getCanResize()) return null;

  const isResizing = header.column.getIsResizing();

  return (
    <div
      onMouseDown={header.getResizeHandler()}
      onTouchStart={header.getResizeHandler()}
      onClick={(event) => event.stopPropagation()}
      className={`absolute right-0 top-0 z-10 h-full w-1.5 cursor-col-resize touch-none select-none ${
        isResizing ? "bg-blue-400" : "bg-transparent hover:bg-slate-300"
      }`}
      aria-hidden
    />
  );
}
